import { Api } from "./Api";
import { AvisDePrelevement } from "../models/AvisDePrelevement";
import _ from "lodash";

export class AvisDePrelevementApi extends Api {
    constructor() {
        super("document/avis-de-prelevement");
    }

    getAll(params?: Object): Promise<Api.CallResponse> {
        return this.getResources(params).then(function (response) {
            let res: Array<AvisDePrelevement> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (a) {
                    return new AvisDePrelevement(a);
                });
            }
            return {
                data: res,
                metadata: response.data.metadata,
                paginator: response.data.paginator,
            };
        });
    }

    get(id: Number, params?: Object): Promise<AvisDePrelevement> {
        return this.getResource(id, params).then(function (response) {
            return new AvisDePrelevement(response.data.data);
        });
    }

    save(
        avisDePrelevement: AvisDePrelevement,
        params?: Object
    ): Promise<AvisDePrelevement> {
        return super
            .saveResource(avisDePrelevement.serialize(), params)
            .then(function (response) {
                return new AvisDePrelevement(response.data.data);
            });
    }

    delete(id: Number, raison: string): Promise<AvisDePrelevement> {
        return super.deleteResource(id, raison).then(function (response) {
            return new AvisDePrelevement(response.data.data);
        });
    }
}
